import React, { useEffect, useState } from 'react';
import style from './style/interpretationscorebar.scss';

export const InterpretationScoreBar = ({ score, saveCompetencyScore, initials = '' }) => {
    const [competencyScore, setCompetencyScore] = useState(null);

    const allowEditing = !!saveCompetencyScore;

    // populate once stored value comes in
    useEffect(() => {
        if (score && (score !== competencyScore)) {
            setCompetencyScore(score);
        }
    }, [score]);

    const getSegment = segmentIndex => {
        let scoreIndicator = null;

        if (Math.ceil(competencyScore * 2) / 2 === segmentIndex) {
            scoreIndicator = <figure className={style.scoreIndicator}>{initials}</figure>;
        }

        return <li
            onClick={() => {
                if (!allowEditing) {
                    return;
                }

                saveCompetencyScore(segmentIndex);
            }}
            className={style.segment}
        >{scoreIndicator}</li>;
    };

    return <div
        className={`${style.interpretationScoreBar} ${allowEditing ? style.interpretationScoreBar__active : ''}`}>
        <ul>
            {getSegment(1)}
            {getSegment(1.5)}
            {getSegment(2)}
            {getSegment(2.5)}
            {getSegment(3)}
            {getSegment(3.5)}
            {getSegment(4)}
            {getSegment(4.5)}
            {getSegment(5)}
        </ul>
    </div>
};
